import { CurrencyEntity } from "../domain/currency.entity";
import {
  GetCurrenciesRequest,
  GetCurrencyRequest,
  UpdateCurrencyRequest,
  Currency,
} from "../../../gen/witbooking/backoffice/currency/v1/currency_api_pb";
import { CurrencyAPIPromiseClient } from "../../../gen/witbooking/backoffice/currency/v1/currency_api_grpc_web_pb";
import { buildGrpcClient } from "../../../lib/grpc";

const grpcClient: CurrencyAPIPromiseClient = buildGrpcClient(CurrencyAPIPromiseClient);

function dtoFromEntity(obj: CurrencyEntity): Currency {
  const result = new Currency();
  result.setId(obj.id);
  result.setName(obj.name);
  result.setCode(obj.code);
  result.setPrimary(obj.primary);
  result.setVisible(obj.visible);
  return result;
}
export async function getAllEntities(token: string): Promise<CurrencyEntity[]> {
  const request = new GetCurrenciesRequest();
  const response = await grpcClient.getCurrencies(request, {
    Authorization: `Bearer ${token}`,
  });
  return response.getCurrenciesList().map(m => m.toObject());
}

export async function getEntity(id: string, token: string): Promise<CurrencyEntity> {
  const request = new GetCurrencyRequest();
  request.setId(id);

  const response = await grpcClient.getCurrency(request, {
    Authorization: `Bearer ${token}`,
  });
  const entity = response.getCurrency();
  if (!entity) {
    throw new Error("Unexpected reply obtaining language");
  }
  return entity.toObject();
}

export async function updateEntity(entity: CurrencyEntity, token: string): Promise<void> {
  const request = new UpdateCurrencyRequest();
  request.setCurrency(dtoFromEntity(entity));
  await grpcClient.updateCurrency(request, {
    Authorization: `Bearer ${token}`,
  });
}
